import styled from 'styled-components';

import { Card as CardComponent } from '@xingternal/card';
import { mediaConfined, mediaWide } from '@xingternal/layout-tokens';
import { spaceL, spaceM, spaceS, spaceXL, spaceXXL } from '@xingternal/tokens';
import { Headline as HeadlineComponent, Meta as MetaComponent } from '@xingternal/typography';

const Card = styled(CardComponent)`
  width: 100%;
  margin: ${spaceXL} 0 0 0;
  padding: ${spaceL} ${spaceXL};

  @media ${mediaConfined} {
    padding: ${spaceXL} ${spaceXXL};
    margin: ${spaceXXL} 0 0 0;
  }

  @media ${mediaWide} {
    padding: ${spaceXL} ${spaceXXL};
    margin: ${spaceXXL} 0 ${spaceL} 0;
  }

  & > div {
    display: flex;
    flex-direction: row;
  }
`;

const Content = styled.div`
  width: 100%;
  margin-left: ${spaceM};
`;

const Headline = styled(HeadlineComponent)`
  margin-bottom: ${spaceS};
`;

const Meta = styled(MetaComponent)`
  margin-bottom: ${spaceM};
`;

export { Card, Content, Headline, Meta };
